import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import React, { FC } from 'react';
import { cn } from '@ui/utils';

export const ImportEmployeesHeader: FC<React.ComponentPropsWithoutRef<'div'>> = (props) => {
  const { className, ...rest } = props;
  const { t } = useTranslation();

  return (
    <div className={cn('mb-8', className)} {...rest}>
      <Typography className="mb-8" variant="h400" element="h1">
        {t('ONBOARDING.IMPORT_EMPLOYEES.HEADER_TITLE')}
      </Typography>
      <Typography variant="paragraphBasicBook" className="max-w-lg">
        {t('ONBOARDING.IMPORT_EMPLOYEES.HEADER_DESCRIPTION')}
      </Typography>
    </div>
  );
};
